export enum InterestType {
	COUNTRY = 'interests_countries',
	DISCIPLINE = 'interests_disciplines'
}
